const OIL = ({ ...props }) => (
  <svg
    version="1.1"
    viewBox="0 0 2048 2048"
    width="1280"
    height="1280"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      transform="translate(969)"
      d="m0 0h112l58 6 46 6 35 6 41 9 32 8 31 9 43 14 42 16 37 16 38 18 25 13 24 14 23 13 23 15 16 10 14 10 18 13 14 10 16 13 13 10 26 22 10 9 8 7 16 15 11 11 8 7 12 13 13 13 7 8 11 12 9 11 10 11 20 25 10 13 14 19 13 19 10 14 11 17 16 26 16 28 11 20 8 16 13 27 13 29 15 37 13 36 10 31 10 35 10 41 8 40 7 45 5 44 4 43v96l-5 58-6 48-4 26-7 37-10 42-10 36-13 41-14 38-14 34-13 29-17 35-14 26-14 24-10 17-15 23-9 14-12 17-10 14-12 16-14 18-13 16-12 14-13 15-12 13-15 16-31 31-8 7-9 9-11 9-12 11-11 9-13 11-12 9-15 12-17 12-14 10-27 18-19 12-15 9-21 12-25 14-17 9-23 11-24 11-36 15-41 15-33 11-43 12-42 10-35 7-46 7-52 6-34 3h-100l-52-5-49-6-37-6-48-10-35-9-44-13-35-12-26-10-29-12-35-16-29-14-28-15-24-14-20-12-22-14-20-14-17-12-19-14-10-8-14-11-11-9-14-12-15-13-13-12-8-8-8-7-30-30-7-8-11-11-9-11-10-11-7-8-13-16-13-17-11-14-12-17-13-18-11-17-14-22-9-15-15-26-14-26-17-34-13-29-15-37-14-38-14-44-11-42-9-39-8-45-6-45-6-61v-112l7-69 7-48 10-50 9-37 10-36 13-40 14-38 13-31 9-20 8-18 8-16 13-25 13-23 16-27 9-14 11-17 8-12 13-18 12-17 11-14 12-15 7-9 13-15 9-11 12-13 7-8 7-7 7-8 31-31 8-7 14-13 11-9 11-10 11-9 14-11 15-12 16-12 17-12 20-14 16-10 20-13 29-17 24-13 29-15 32-15 33-14 34-13 47-16 42-12 33-8 39-8 49-8 32-4 41-4zm-81 394-12 4-11 7-8 8-7 12-3 9-1 5v12l4 32 1 14v47l-2 21-5 27-7 25-7 19-8 18-10 19-12 19-14 19-9 10-9 11-19 19-8 7-15 13-13 10-18 13-11 8-9 8-10 14-13 20-17 29-17 33-14 32-11 29-11 34-10 40-6 31-4 28-3 30-1 17v55l3 39 4 31 7 38 6 22 10 28 13 29 10 20 16 27 15 22 16 21 13 15 9 10 12 13 4 2v2l8 7 14 13 11 9 14 11 19 13 15 10 26 15 24 12 29 12 28 10 25 7 28 6 32 5 18 2 16 1h40l26-2 31-4 30-6 30-8 27-9 27-11 31-15 23-13 24-16 14-10 14-11 14-12 24-22 7-8 8-8 7-8 14-17 9-12 14-20 15-25 8-14 11-23 9-21 8-21 6-21 7-35 4-27 3-27 2-36v-38l-3-43-5-38-5-27-7-31-9-31-10-30-12-30-12-26-12-24-13-23-16-26-11-16-9-12-7-7-10-6-9-3-5-1h-17l-13 4-11 7-7 7-7 11-4 13-4 26-5 22-5 16-8 19-8 14-10 14-8 9-1-1-5-39-8-43-8-35-12-41-12-35-14-35-16-35-18-35-16-27-11-18-12-18-12-17-14-19-14-17-8-10-10-11-9-11-7-7-7-8-27-27-8-7-12-11-11-9-14-12-16-12-12-6-7-2z"
      fill="#3CA6DD"
    />
    <path
      transform="translate(145,519)"
      d="m0 0 2 4-4 2-1 11 4-2 3 7-1 9 1 5 7 6 1-3h4l2-2 2 1 1-2 6-2 4 1 1 2 4 2v3l2 2 2 4-1 1 7 2 6 2 6 4 1 9-1 3 3 1v12l1 3-2 8 3 9 7 2h2l2-5 4-1v-3l3 1v7l6-3 1-2h2l2-4 4-2 3 5 3-5 5-1 6-1 1-2 6 1 2 4v9l2 7 2 4v5l3 5v4 14l1 2 5-3 7-1 1 5-4 2 1 5 5 1 1 3 3 1v16l-1 4h3l3 5-2 8 3 12v4h-2l1 12h2v2h2l4 4 5 3 5 5 7 6 3 1 1-3 3-1 5 3 6 2 1 5 2 1 1-2h5v-2h2v2l2 1 3 1 2-2h3l4 7 7-1 2 6 7-1 2 6-3 1-1 2h2l1-2 3 3 3-1 3 3 3 7h11v-2h2l2-4 5-3h7l1-9 6 2 2 4-1 8h8l4-1 5 1h3l3-3 4-2 2 2-1 5-3 2h3v-1h8l3-4 6 1 4-2 6-1 3-1 2 2-1 6-1 3h-2l-1 8h5l1 3h3l5 6 1 3-1 2 4-1 2-2 5-3h2l1-2 2 6 1 2h3l1 4 3 1v2l5 1v2l6 2 4 1h2l-1 4 3 1 1 2 4 2 3 2v3l4-2 1 2-2 8-1 8 6-2h4l3 6 4 3h4l1-2 3 1v2l5 1 6-3 6-2 8-12 6-2h8l2-4 3-4 3-6h1l-1 11-1 6-2 6h1l16-26 9-14 8-11 7-8 5-5 5-4 5-1 2-5 1-2 7-3 2-5v-4l2-4 3-3-4 2 2-4 5-4 5-5 9-4 6-4 5-5h2v-2h5l2-4h2l1-3 11-8 8-8h3l4-6 10-10 3-2-1 4 4-1 2 5v3l-3 1-2 4-2-1-1-1v5l-6 7-4 9h-2l-2 5-1 2h-2l-1 9-15 14-11 9-14 11-18 13-11 8-8 7-10 14-13 20-17 29-17 33-14 32-11 29-11 34-10 40-6 31-4 28-3 30-1 17v55l3 39 4 31 7 38 6 22 10 28 13 29 10 20 16 27 15 22 16 21 13 15 9 10 12 13 3 2v2l4 2 10 10 11 9 9 8 13 10 19 13 15 10 26 15 24 12 29 12 28 10 25 7 28 6 32 5 18 2 16 1h40l26-2 31-4 30-6 30-8 27-9 23-9 1 3 18-6 15-4 12-7 7-5 7-1 9-4 2 1-3 3 2 2-13 11-4 2-7 8-5 7-8 7-6 10-3 9 15-4h3l4 4v2h7l6-1 6 2 14-1 7-2h8l2-1h15l12 4h5v2h2l5 5 3 4v9h7l4 2 7 1 9-1 3 1 11 1 4 1v3l-3 1v8l3-1 3 1-2 4-6 7v5h2v3l8-3h7l6 4 8-1 2-4 7 2 13-1 10-4 7-1 6-5 4-1 1 4-2 5h-4v-2l-3 3h5v2h2v-2h6l1 2 4 1 1-2 1 4-5 8v6l-2 2 1 3h10l3-2 4 1 4 2 1 2 2 3 5 1 4 2 2 7 4 2 4 5-2 3h2l3 3 2 1v2h3l-1 5h2l-1 8h-2l2 5v3l9-3 4-1 1-3h4v-2h2l-1 6v4l-1 7 2 5 4 2 7 1 4 2 4-2 5 2v2l-6 1-2 7h-2l1 3 2-1 5 1 3-2 15-2 3 1h8l1-1h7l4-2 7 1v-2l9-2 12-6 5-2 2-3 8-2 12-6h4l-4 6-8 4-3 6 2 1 6-3h2l2-4 7-3 1-2 11-6 3-4 11-6h2v-2l6-3v3h2v2h2l2-4 5-5 3-4v-2l4-2v-2h2l2-5-3-1 8-9-3-1 3-1 2-4 2-5-2-1v-2h2l1-5h2v-2h2v-2l3-1 8-8h2v-3l6-5h2v-2l6-3 7-8 2-5 3-3h2l2-4 5-4 3-4h2l2-4 4-6h2l2-4 5-5 4-2v2l6-1 5-3 1 4-1 4-6 4-1-2-2 4h-2l-2 6-1 4-5 7-4 1-2 5-7 7-4 7-3 5-5 5-5 7 1 6-16 17-31 31-8 7-9 9-11 9-12 11-11 9-13 11-12 9-15 12-17 12-14 10-27 18-19 12-15 9-21 12-25 14-17 9-23 11-24 11-36 15-41 15-33 11-43 12-42 10-35 7-46 7-52 6-34 3h-100l-52-5-49-6-37-6-48-10-35-9-44-13-35-12-26-10-29-12-35-16-29-14-28-15-24-14-20-12-22-14-20-14-17-12-19-14-10-8-14-11-11-9-14-12-15-13-13-12-8-8-8-7-30-30-7-8-11-11-9-11-10-11-7-8-13-16-13-17-11-14-12-17-13-18-11-17-14-22-9-15-15-26-14-26-17-34-13-29-15-37-14-38-14-44-11-42-9-39-8-45-6-45-6-61v-112l7-69 7-48 10-50 9-37 10-36 13-40 14-38 10-24h5l1-4 5-12 2-7 7-13h2l1-4 1-3h2l1-5 6-11 5-8 3-7 2-1 1-5h2l1-5 6-4h2l3-9z"
      fill="#5E84C3"
    />
    <path
      transform="translate(953,569)"
      d="m0 0 4 2 22 26 10 13 14 19 16 24 12 19 14 25 10 19 14 29 14 34 12 34 10 35 7 29 6 31 5 35 3 35 1 20 1 43 3 12 5 10 9 10 10 7 10 4 5 1h17l13-4 25-11 20-11 21-14 13-10 9-8h2v-2l8-7 7-7 7-8 12-15 10-15 7-12 3 3 14 37 10 32 8 34 6 35 4 40v66l-4 39-6 35-6 23-11 28-9 19-13 23-11 17-10 14-14 17-9 10-15 16-8 7-5 4 1-5 8-19 6-20 5-26 3-27 1-18v-19l-2-28-4-27-6-27-8-26-10-25-13-27-13-22-11-16-9-10-9-6-9-4-11-2-16 1-13 5-12 9-7 9-2-2-5-15-8-21-13-29-10-19-12-20-10-15-13-18-11-13-9-11-15-16-10-10-8-7-10-9-17-13-11-5-14-3-14 1-13 5-11 8-7 8-5 10-3 11v18l2 18v22l-2 15-4 16-6 16-9 16-9 12-9 10-12 12-14 11-16 12-8 8-13 20-9 16-8 15-12 28-8 24-7 27-5 29-2 22-1 26 2 33 4 28 5 22 5 15 5 11v2l-4-2-14-14-7-8-11-13-12-16-12-18-14-24-12-25-10-26-6-22-6-34-4-38-1-20v-35l2-29 3-26 6-34 10-40 11-33 11-27 9-20 15-29 7-11 5-9 10-15 9-8 19-14 16-13 11-9 12-11 15-14 8-8 7-8 11-12 9-11 10-13 14-20 16-27 8-15 10-22 6-15 8-25 7-28 6-32z"
      fill="#3CA6DD"
    />
    <path
      transform="translate(922,881)"
      d="m0 0h22l8 3 3 1h5l5 5-3 3h-11l-5 5-5 1 1 6-16 8-10 9-6 9-4 11-1 5v18l2 18v22l-2 15-4 16-6 16-9 16-9 12-9 10-12 12-14 11-16 12-8 8-13 20-9 16-8 15-12 28-8 24-7 27-5 29-2 22-1 26 2 33 4 28 5 22 5 15 5 11v2l-4-2-14-14-7-8-11-13-12-16-12-18-14-24-12-25-10-26-6-22-6-34-4-38-1-20v-35l2-29 3-26 3-18 2 1 2-1 6-24 2-7 3-7h2l2-9 4-4 1-7 6-4h3l2-4 2 1v6l-2 3v5h2l2-4 3-7 2-9h4l4 2 3 6-1 3 4-1 1 5-3 3 1 4h2l1 2v6h-2v4l2-2v5l2 1 1 3h2l1 7-3 8h5l2 4h2v-2h6l2-5 4-7 3-5 3-1 1-2h3l-1 7-3 4-1 5 4-4 6-1 2 1v2l-2 1-1 5-3 9-3 11-1 5 7 2 7-6 7-4 3-3 7-3 7-2 4-3h5l5-2v-2l5-3h5l1 2 4-1 7-5h7l1-1h5l3 3 4-2 2 2-1 5-2 3 4-4h2v-2l7-6 4-6 4-4 3-5 3-3 6-16 3-7v-8l2-13v-6h-5l-2-5 1-9h-2l-1 5h-3l-5 1-5-2-6-2h-2l-2 5-2 3-5-1-1-5h-2l-1-9-1-5-5-2-6 3h-5l1 5-4 3 3 1-1 6-5-3-3-8-4-4-1-9-3 3-3-1 1-11 1-5 3 1 2-4 2-2 2-13 3 1 2-11 8-10 3-8 5-8 8-7 5-2-2 4-5 5h1l7-4 4-3 12-2 10 4h2l1-4 3-2-2 7-1 2 3 8 3 1 2-2 9-3 11-8 7-4z"
      fill="#5D84C3"
    />
    <path
      transform="translate(310,1740)"
      d="m0 0 3 1 10 10 4 5 6 4 2 4 4-1 6 4 2 3 3 1-1-4-2-3v-4l4 1 4 5 2 7 7 2 1 5v3l2 1-1 6 5 3 5 2v2l4 1 1-2 4 6 8 5 4 5 4-1 1 5 4 2 3 7 6 1 1 3 5-1 2 4 9 2 3 5 3 2v4h3l4 5 3 1v2l4 2 7 4 4 4 8 3 2 4 7 2 12 6 9 2 4 2v4l4 1 3-1 1-4 3 1v2l6 2 1 6 6-1 9 5 5 1v7l7-1 1-2h3v3l9 1 2 5 12 4 5 1 3 3 9 4 4 1 4 2 7 2 5 3 8 3h5v2h2l2 3 9 3 1 2h6l2 1v2l4 2 6 1 3 2 7 1 3 3 7 1 3 2 8 2 4 4h7l7 3 24 8 5 2 4 1v2h10l6 8 7 1 3 1 1-2 3 5 3 2v2l10 1 2 1v2l15 2 12 1 4 1 10 1 3 2h9l7 1 1 1 11 2 9 2 8 1 2 1 19 1 9 3 5 2-3 1 2 5-14 1h-27l-6 1-1-5-18-1-1 3 2 2-1 1h-7l-48-10-35-9-44-13-35-12-26-10-29-12-35-16-4-2v-2h-2l-5-5-7-4-8-4-6-4-5-2v-2l-7-1-3-3-5-2-2-3-6-2-8-5-4-1-3-3-3-2v-2l-6-2-3-2-6-2-4-3v-3l-5-1-11-9-2 1-2-1v-2l-5-2-1-3-5-1-5-4v-3l-6-2-5-2-3-5-5-2v-2h-5l-9-6v-2h-2v-2l-4-1-5-5-10-7-4-2-2-5-7-4-9-6-8-11-3-3v-2h-4v-2l-7-2v-2l-4-2-9-8-3-4v-2h-2v-2h-2l-3-5v-2h-2v-2l-4-2-4-4v-2h-2v-2h-2l-3-4v-2h-2z"
      fill="#6479BC"
    />
    <path
      transform="translate(1365,1251)"
      d="m0 0 2 3v3h3l-1 6 2 4v10h-3v4l4-1 2-2 2-4 1 3-5 21-7 20-11 26-15 28-13 20-10 14-14 17-9 10-15 16-8 7-5 4 1-5 8-19 6-20 5-26 3-27 1-18h1v5h2l1-6h2l-1-3 2-12v-8l4-12v-11l-1-7 2-3h3v2h2l1 4 3 7 5-2 4 1-2 10 5 5 2 9 6-1 6-2 4-6 4-5 1-3 2-1 4-13 2-9 5-5 3-15 3-12z"
      fill="#5D84C3"
    />
    <path
      transform="translate(50,1306)"
      d="m0 0 5 1 2 7 2 5 2 4 1 7 3 7 7 18 3 8 2 3 3 9 2 8h2l2 3 3 10 2 6v3h2l4 11-1 8 3 9h3l1-2 5 9h-3l1 5 2 4v4h2l2 4v3l4 2 6 14 4 6 2 4 2 1v4l3-1 3 3 6 9 2 1 3 7-1 5-1 1 1 4 7 9 4 2 2 2 4 1v2l3 1 2 5 5 8 4 7-1 2h2l1 3 2 2 4 3v6l9 4-1 12 3 1 4 4 1 6 4 1 5 12v2l4 2 5 5 3 6 3 1 2 6 5 6 5 10 4 5v2l6 2 5 5 2 10 1 4 2 5-4 1-11-9-10-6 2-2-1-4-4-4-4-2v-3l-5-2-4-2v-5l-1-5-5-1-3-4-4-2-1-3-4-1-12-17-14-20-14-22-12-19-16-28-9-16-14-27-6-12-1-6-2-8-2-1-1-7-3-2 1-1-2-2 1-5-1-3h-3v-9l-3-4-4-6-2-1 3-1v-2l-2-1 1-1-2-1-1-6-2-5-2-2 1-4h2l-2-4v-3l-2-1-1-4-1-5-2-1-1-6-5-15-2-10 1-5-4-3v-6l-5-8-2-12z"
      fill="#6379BC"
    />
    <path
      transform="translate(1113,1007)"
      d="m0 0h2l3 26 1 9v2l4 10 5 8 8 12 3 5 11 7 3 1v2l9 2 6 3v4h-3v2l-6 3-4 4-10 2-4-1v-2l-4-1-4-9-3-6-2-7-7-16-8-16-6-14-1-7v-14l5-5z"
      fill="#5E84C3"
    />
    <path
      transform="translate(1325,1330)"
      d="m0 0 3 1v2l3-1v5l2 1-3 10v3l-6 11v3l-2 3v4l-6 5-6 8-4 3-7 1-5 11h-2l-1 7-5 5-2-3 2-3 2-2 1-6-1-2 5-5 3-6h2v-4h-3l2-7 4-2v-12l2-6 3 1 3-6 2 4 3-7 1-6 4 3 4 1v2l2-1 1-5-3-1 1-8z"
      fill="#3CA6DD"
    />
    <path
      transform="translate(787,854)"
      d="m0 0 4 1-1 3-2 1-5 6-2 2-4 1-2 5-6 5h-2v2l-3 3-1 3-7 5h-2v2l-3 2h-3l-2 4-1 1v7h-2l-1 4-7 8-3 1-3 11-4 8-3 5-3 4-2 1v3l-3 4-1-1-3 6-3-1 12-25 13-24 10-16 8-12 9-8 19-14z"
      fill="#5C86C4"
    />
    <path
      transform="translate(730,919)"
      d="m0 0 2 1-3 11-4 8-3 5-3 4-2 1v3l-3 4-1-1-3 6-3-1 12-25 8-15z"
      fill="#5A87C5"
    />
    <path
      transform="translate(266,1691)"
      d="m0 0 1 3 2-1 4 7 6 7v2l4 2 3 5-1 2-9-6-1-3h-2l-3-5v-3l-5-1-4-4 1-3z"
      fill="#6479BC"
    />
    <path
      transform="translate(950,892)"
      d="m0 0 4 1 2 2 2 4 1 3 2 2h-10l-9 1-3-5 2-2 7-2z"
      fill="#3DA5DD"
    />
    <path
      transform="translate(718,938)"
      d="m0 0 4 2-1 6-4 3v3l-3 4-1-1-3 6-3-1 10-21z"
      fill="#598BC8"
    />
    <path
      transform="translate(826,2023)"
      d="m0 0h10l4 2v6l-9-1-9-2-1-4z"
      fill="#5F85C3"
    />
    <path
      transform="translate(93,597)"
      d="m0 0h2l-1 5-4 11-3 8-2 4-4 1 1-6 10-22z"
      fill="#45A5DB"
    />
    <path
      transform="translate(287,1719)"
      d="m0 0 5 1 5 5 4 2 3 3 3 9h-3l-4-4v-2h-2v-2h-2l-7-8v-2h-2z"
      fill="#6479BC"
    />
    <path
      transform="translate(560,868)"
      d="m0 0 2 1v2h2l1-2 2 1v2h-2l1 3-6 5h-3v-6l1-4z"
      fill="#3CA7DE"
    />
    <path
      transform="translate(1289,1366)"
      d="m0 0 3 2 1 5-3 4-2 5h-1l1-15z"
      fill="#3CA6DD"
    />
    <path
      transform="translate(78,630)"
      d="m0 0h3v2l-3 3 2 1-2 3-2 6-3 1-1-2z"
      fill="#4CA2D9"
    />
    <path
      transform="translate(954,895)"
      d="m0 0h3l2 7 2 2-9-1v-7z"
      fill="#5D84C3"
    />
    <path
      transform="translate(21,1167)"
      d="m0 0 3 1v10l-3 2-1-5v-2l-1-5z"
      fill="#6479BC"
    />
    <path
      transform="translate(166,468)"
      d="m0 0 2 2-5 5 1 2-7 2 5-9z"
      fill="#5F89C6"
    />
    <path
      transform="translate(595,1953)"
      d="m0 0h7l4 3 4 1 2 4-9-3-8-4z"
      fill="#5E84C3"
    />
    <path
      transform="translate(171,457)"
      d="m0 0 4 1-4 6h-2v2h-3l2-5z"
      fill="#5C8DC9"
    />
    <path
      transform="translate(172,1591)"
      d="m0 0 3 1v3l4 1 2 3-2 4-7-10z"
      fill="#5E84C3"
    />
    <path
      transform="translate(1268,1451)"
      d="m0 0 5 1-6 7-2 1 1-5z"
      fill="#3CA7DE"
    />
    <path
      transform="translate(22,1196)"
      d="m0 0h5l1 1v5h-3l-1-2-2-1z"
      fill="#6479BC"
    />
    <path
      transform="translate(164,1579)"
      d="m0 0 3 1v3l4 1 1 7-4-4z"
      fill="#5E84C3"
    />
  </svg>
);
export default OIL;
